import { REQUEST_YOUTUBE_VIDEOS_SUCCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { videos: {}, errors: null };

export default function getYoutubeVideos(state=INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_YOUTUBE_VIDEOS_SUCCCESS:
      
      
      return { ...state, videos: action.payload.data, errors: null }
    default:
      return state;
  }
}